<menu class="flex gap-5 items-center place-content-center p-[60px]" *transloco="let t">
    <div class="cursor-pointer hidden lg:block text-secondary text-[18px] font-medium hover:underline"
        [ngClass]="{'underline': current == 0}" (click)="current = 0;goTo(t('routes.booking.path'))">
        {{t('routes.booking.menu')}}</div>
    <div class="cursor-pointer hidden lg:block text-secondary text-[18px] font-medium hover:underline"
        [ngClass]="{'underline': current == 1}" (click)="current = 1;goTo(t('routes.ships.path'))">
        {{t('routes.ships.menu')}}</div>
    <div class="mx-auto">
        <img class="h-[60px]" src="./assets/logo.png">
    </div>
    <std-click-outside (clickOutside)="showLang = false"> <std-tooltip position="top"
            classTooltip="!w-fit bg-white shadow-xl" [show]="showLang">
            <div class="flex gap-5 px-2" tooltip>
                <div content class="cursor-pointer text-[22px] hidden lg:block" (click)="changeLang('it')">🇮🇹</div>
                <div class="cursor-pointer text-[22px] hidden lg:block" (click)="changeLang('en')">🇺🇸</div>
                <div class="cursor-pointer text-[22px] hidden lg:block" (click)="changeLang('de')">🇩🇪</div>
                <div class="cursor-pointer text-[22px] hidden lg:block" (click)="changeLang('es')">🇪🇸</div>
                <div class="cursor-pointer text-[22px] hidden lg:block" (click)="changeLang('fr')">🇫🇷</div>
            </div>
            <div content class="cursor-pointer select-none text-[22px] hidden lg:block" (click)="showLang = true">
                @if(currentLangIcon == 0){🇮🇹}
                @if(currentLangIcon == 1){🇺🇸}
                @if(currentLangIcon == 2){🇩🇪}
                @if(currentLangIcon == 3){🇪🇸}
                @if(currentLangIcon == 4){🇫🇷}
            </div>
        </std-tooltip></std-click-outside>
    <div class="cursor-pointer hidden lg:block text-secondary text-[18px] font-medium hover:underline"
        [ngClass]="{'underline': current == 2}" (click)="current = 2;goTo(t('routes.who.path'))">
        {{t('routes.who.menu')}}</div>
    <div class="cursor-pointer hidden lg:block text-secondary text-[18px] font-medium hover:underline"
        [ngClass]="{'underline': current == 3}" (click)="current = 3;goTo(t('routes.contacts.path'))">
        {{t('routes.contacts.menu')}}</div>
    <div class="cursor-pointer hidden lg:block text-secondary text-[18px] font-medium hover:underline"
        [ngClass]="{'underline': current == 4}" (click)="current = 4;goTo(t('routes.profile.path'))">
        {{t('routes.profile.menu')}}</div>
    <div class="cursor-pointer hidden lg:block text-secondary text-[18px] font-medium hover:underline"
        [ngClass]="{'underline': current == 5}" (click)="current = 5;goToManger()">{{t('routes.manager.menu')}}</div>
    <div class="ml-auto mr-[5px] lg:hidden cursor-pointer overflow-hidden" (click)="activateMenu()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.00098 18.0002H21.001V16.0001H3.00098V18.0002ZM3.00098 13.0001H21.001V11.0004H3.00098V13.0001ZM3.00098 6.00024V8.00039H21.001V6.00024H3.00098Z"
                fill="#1F299C" />
        </svg>

    </div>
    @if (showMenu) {
    <div (click)="showMenu = false"
        class="transition-all lg:hidden w-full bg-white absolute top-0 z-[96] overflow-hidden animation-open-menu rounded-[30px]"
        [ngClass]="{'animation-close-menu': closeMenu}" style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.16)">
        <div class="cursor-pointer lg:block mx-auto text-primary font-semibold text-center text-[22px] pt-2 hover:underline"
            [ngClass]="{'underline': current == 0}" (click)="current = 0;goTo(t('routes.booking.path'))">
            {{t('routes.booking.menu')}}</div>
        <div class="cursor-pointer lg:block mx-auto text-primary font-semibold text-center text-[22px] pt-2 hover:underline"
            [ngClass]="{'underline': current == 1}" (click)="current = 1;goTo(t('routes.ships.path'))">
            {{t('routes.ships.menu')}}</div>

        <div class="cursor-pointer lg:block mx-auto text-primary font-semibold text-center text-[22px] pt-2 hover:underline"
            [ngClass]="{'underline': current == 2}" (click)="current = 2;goTo(t('routes.who.path'))">
            {{t('routes.who.menu')}}</div>
        <div class="cursor-pointer lg:block mx-auto text-primary font-semibold text-center text-[22px] pt-2 hover:underline"
            [ngClass]="{'underline': current == 3}" (click)="current = 3;goTo(t('routes.contacts.path'))">
            {{t('routes.contacts.menu')}}</div>
        <div class="cursor-pointer lg:block mx-auto text-primary font-semibold text-center text-[22px] pt-2 hover:underline"
            [ngClass]="{'underline': current == 4}" (click)="current = 4;goTo(t('routes.profile.path'))">
            {{t('routes.profile.menu')}}</div>
        <div class="cursor-pointer lg:block mx-auto text-primary font-semibold text-center text-[22px] pt-2 hover:underline"
            [ngClass]="{'underline': current == 5}" (click)="current = 5;goToManger()">{{t('routes.manager.menu')}}
        </div>
        <div class="flex gap-5 mx-auto">
            <div class="cursor-pointer lg:block mx-auto text-[34px]" (click)="changeLang('it')">🇮🇹</div>
            <div class="cursor-pointer lg:block mx-auto text-[34px]" (click)="changeLang('en')">🇺🇸</div>
            <div class="cursor-pointer lg:block mx-auto text-[34px]" (click)="changeLang('de')">🇩🇪</div>
            <div class="cursor-pointer lg:block mx-auto text-[34px]" (click)="changeLang('es')">🇪🇸</div>
            <div class="cursor-pointer lg:block mx-auto text-[34px]" (click)="changeLang('fr')">🇫🇷</div>
        </div>
    </div>
    }
</menu>